import { MessageProxy } from "@intelligems/ig-embedded-preview/MessageProxy";
import { AppListenerMiddleware } from "@src/store";
import { getEmbeddedState } from "@src/store/slices/experienceBuilder/common/selectors/getEmbeddedState";

export const setupSendPreviewStateListener = (
  middleware: AppListenerMiddleware,
  messageProxy: MessageProxy
) =>
  middleware.startListening({
    predicate: (_, curr, prev) =>
      getEmbeddedState(curr) !== getEmbeddedState(prev),
    // IMPORTANT: must remain synchronous (no `async`). Any AI-turn code path
    // that mutates embedded state and then dispatches `requestPageHtml`
    // relies on this effect's `ig-previewState` postMessage being queued
    // BEFORE the capture's `ig-getPageHtml` postMessage. Going async would
    // let the capture overtake the state update at the iframe, leaving the
    // plugin to respond with a pre-update DOM snapshot.
    effect: (_, { getState }) => {
      messageProxy.send("ig-previewState", getEmbeddedState(getState()));
    },
  });
